import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as MergeCellsIcon } from 'assets/icons/merge.svg';
import { ReactComponent as SplitCellIcon } from 'assets/icons/split.svg';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { preventDefault } from 'utils/event';

interface CellProps {
  onChange?: () => void;
}

export const MergeCells = memo(({ onChange }: CellProps) => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false, keyPrefix: 'merge' });
  const label = t('text');
  const ariaLabel = t('ariaLabel');

  return (
    <Tooltip hasArrow placement='bottom' label={label} bg='black'>
      <IconButton
        onClick={onChange}
        onMouseDown={preventDefault}
        size='sm'
        aria-label={ariaLabel}
        icon={<MergeCellsIcon />}
        variant='icon-btn-toolbar'
      />
    </Tooltip>
  );
});
MergeCells.displayName = 'MergeCells';

export const SplitCell = memo(({ onChange }: CellProps) => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false, keyPrefix: 'unmerge' });
  const label = t('text');
  const ariaLabel = t('ariaLabel');

  return (
    <Tooltip hasArrow placement='bottom' label={label} bg='black'>
      <IconButton
        onClick={onChange}
        onMouseDown={preventDefault}
        size='sm'
        aria-label={ariaLabel}
        icon={<SplitCellIcon />}
        variant='icon-btn-toolbar'
      />
    </Tooltip>
  );
});

SplitCell.displayName = 'SplitCell';
